import React from "react";
import { motion } from "framer-motion";
import { useSiteContent } from "@/context/SiteContentContext";

export default function AboutCharles() {
  const content = useSiteContent();
  const a = content?.about_charles;
  if (!a) return null;

  return (
    <section id="about" data-testid="about-section" className="relative py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
        <div className="lg:col-span-5">
          <div className="lg:sticky lg:top-32">
            <div className="flex items-center gap-3 mb-4">
              <span className="h-px w-12 bg-orange-600" />
              <span className="text-xs tracking-[0.25em] uppercase text-slate-500 font-display">
                {content?.sections?.about_label || "About Charles"}
              </span>
            </div>
            <h2 className="font-serif-sc text-4xl lg:text-5xl xl:text-6xl font-bold text-slate-900 leading-tight tracking-tight">
              {a.heading_top}<br />
              <span className="text-orange-600">{a.heading_bottom}</span>。
            </h2>
            <div className="mt-8 space-y-4 text-slate-600 leading-relaxed text-base">
              {a.paragraphs?.map((p, i) => (
                <p key={i} className="whitespace-pre-line">{p}</p>
              ))}
            </div>

            <div className="mt-10 flex flex-wrap gap-3">
              {a.tags?.map((tag) => (
                <span
                  key={tag}
                  className="px-4 py-2 border border-slate-300 text-xs tracking-wider text-slate-700 font-display uppercase rounded-full hover:border-orange-600 hover:text-orange-600 transition-colors"
                >
                  {tag}
                </span>
              ))}
            </div>
          </div>
        </div>

        <div className="lg:col-span-7" data-testid="journey-timeline">
          <div className="relative pl-8 lg:pl-10 border-l border-slate-200">
            {a.timeline?.map((item, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, x: 20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="relative pb-12 last:pb-0"
                data-testid={`journey-item-${i}`}
              >
                <div className="absolute -left-[37px] lg:-left-[45px] top-2 w-3 h-3 rounded-full bg-orange-600 ring-4 ring-orange-100" />
                <div className="font-display text-sm tracking-[0.2em] uppercase text-orange-600">
                  {item.year}
                </div>
                <h3 className="font-serif-sc text-2xl lg:text-3xl text-slate-900 mt-2 font-semibold">
                  {item.title}
                </h3>
                <p className="mt-3 text-slate-600 leading-relaxed max-w-lg">{item.text}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
